import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { PrimaryButton } from '@component/Button';
import { FamilycrestList } from '@component/Familycrest';
import { Spinner } from '@component/Spinner';
import type { AsyncGeneralState, PartsProduct } from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';
import { fetchFamilyCrestList } from '@app/react/action/FetchFamilyCrestList';

const selectorState = (
    state: AppState,
): AsyncGeneralState => state.uiOrderPartsHelp.fcLoadState;

const selectorItems = (
    state: AppState,
): Array<PartsProduct> => state.uiOrderPartsHelp.familycrestList?.partsData ?? [];

const Header: FC<{ goBack: () => void }> = ({ goBack }) => (
    <div className="familycrest-list-panel-header">
        <div className="navi-container">
            <div className="left">
                <PrimaryButton
                    className="go-back"
                    dark
                    radius={170}
                    onClick={goBack}
                >
                    ＜ 戻る
                </PrimaryButton>
            </div>
            <span className="title">家紋の一覧</span>
            <div className="right" />
        </div>
    </div>
);

interface Props {
    goBack: () => void;
}

export const OrderPartsHelpFamilycrestContainer: FC<Props> = (props) => {
    const { goBack } = props;

    const dispatch = useDispatch();
    const state = useSelector(selectorState);
    const items = useSelector(selectorItems);

    const rootClassName = classNames('', {
        'spinner-wrapper': state === 'request',
    });

    useEffect(() => {
        dispatch(fetchFamilyCrestList.started({}));
    }, [dispatch]);

    return (
        <div className={rootClassName}>
            <Header goBack={goBack} />
            {state === 'request' && (
                <div className="spinner-container">
                    <Spinner />
                </div>
            )}
            {state === 'done' && (
                <FamilycrestList
                    selectable={false}
                    value={null}
                    items={items}
                    onClick={() => false}
                />
            )}
        </div>
    );
};
